import activitiesTypes from './activities-types'
import channels from './channels'
import customersFormSettings from './customers-form-settings'
import contactLinks from './contact-links'
import funnelsManagement from './funnels-management'
import roulettesFields from './roulettes-fields'
import tags from './tags'

export default [
  ...activitiesTypes,

  ...channels,

  ...customersFormSettings,

  ...contactLinks,

  ...funnelsManagement,

  ...roulettesFields,

  ...tags,

  {
    name: 'SettingsList',
    path: '/settings',
    component: () => import('pages/settings/SettingsList.vue')
  }
]
